'use server-only';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
type MobileMenuLinkProps = {
  href: string;
  title: string;
  isHighlighted?: boolean;
  onClick?: () => void;
};
export function MobileMenuLink(t0) {
  const $ = _c(5);
  const {
    href,
    title,
    isHighlighted: t1,
    onClick
  } = t0;
  const isHighlighted = t1 === undefined ? false : t1;
  const textColor = isHighlighted ? "text-algoprimary" : "text-slate-900";
  const t2 = `${"-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 hover:bg-slate-50"} ${textColor}`;
  let t3;
  if ($[0] !== href || $[1] !== onClick || $[2] !== t2 || $[3] !== title) {
    t3 = <Link href={href} className={t2} onClick={onClick}>{title}</Link>;
    $[0] = href;
    $[1] = onClick;
    $[2] = t2;
    $[3] = title;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}